import { COMPANY_PARTNERS_OF_EMPLOYEE } from '../Queries'
import { ApolloError, useQuery } from '@apollo/client'
import { CompanyPartnersOfEmployeeQuery, CompanyPartnersOfEmployeeQueryVariables } from '../../../types'

export default (
  employeeId: number,
): { data: CompanyPartnersOfEmployeeQuery | undefined; error: ApolloError | undefined; loading: boolean } => {
  const variables = {
    employeeId: employeeId,
  }

  const { data, error, loading } = useQuery<CompanyPartnersOfEmployeeQuery, CompanyPartnersOfEmployeeQueryVariables>(
    COMPANY_PARTNERS_OF_EMPLOYEE,
    {
      variables: variables,
    },
  )

  return { data, error, loading }
}
